export const TASK_PANEL_LOADING_SET = 'at/panels/task/create/TASK_PANEL_LOADING_SET'
export const TASK_PANEL_LOADED_SET = 'at/panels/task/create/TASK_PANEL_LOADED_SET'
export const TASK_INFO_SET = 'at/panels/task/create/TASK_INFO_SET'
export const OPEN_TASK_SET = 'at/panels/task/create/OPEN_TASK_SET'
export const TASK_PANEL_ERRORS_ADD = 'at/panels/task/create/TASK_PANEL_ERRORS_ADD'
export const TASK_PANEL_ERRORS_SET = 'at/panels/task/create/TASK_PANEL_ERRORS_SET'
export const TASK_PANEL_ERRORS_REMOVE = 'at/panels/task/create/TASK_PANEL_ERRORS_REMOVE'
export const TASK_PANEL_SHOWN_SET = 'at/panels/task/create/TASK_PANEL_SHOWN_SET'

export const TASK_PANEL_TAB_SET = 'at/panels/task/create/TASK_PANEL_TAB_SET'
export const TASK_PANEL_LAST_TAB_SET = 'at/panels/task/create/TASK_PANEL_LAST_TAB_SET'

export const CREATE_TASK = 'at/panels/task/create/CREATE_TASK'
export const CREATE_TASK_SUCCESS = 'at/panels/task/create/CREATE_TASK_SUCCESS'
export const CREATE_TASK_FAILURE = 'at/panels/task/create/CREATE_TASK_FAILURE'

export const ASSIGNED_USERS_SET = 'at/panels/task/create/TASK_PANEL_ASSIGNED_USERS_SET'
export const CAN_MODIFY_ANY_MANAGER_SET = 'at/panels/task/create/TASK_PANEL_CAN_MODIFY_ANY_MANAGER_SET'
export const CAN_MODIFY_ANY_USER_SET = 'at/panels/task/create/TASK_PANEL_CAN_MODIFY_ANY_USER_SET'
export const ASSIGNED_MANAGERS_SET = 'at/panels/task/create/TASK_PANEL_ASSIGNED_MANAGERS_SET'

export const ADDED_ASSIGNED_USER_IDS_SET = 'at/panels/task/create/ADDED_ASSIGNED_USERS_IDS_SET'
export const ADDED_ASSIGNED_MANAGER_IDS_SET = 'at/panels/task/create/ADDED_ASSIGNED_MANAGERS_IDS_SET'
export const CREATE_PANEL_STATE_RESET = 'at/panels/task/create/CREATE_PANEL_STATE_RESET'

export const TASK_PANEL_STATE_RESET = 'at/panels/task/create/TASK_PANEL_STATE_RESET'

export const TASK_DATA_DEFAULT_STATE_PROPERTY_SET = 'at/panels/task/create/TASK_DATA_DEFAULT_STATE_PROPERTY_SET'

export const NEED_INITIALIZE_FOCUS_SET = 'at/panels/task/create/NEED_INITIALIZE_FOCUS_SET'

export const CUSTOM_FIELDS_VALUES_UPDATE = 'at/panels/task/create/CUSTOM_FIELDS_VALUES_UPDATE'



// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/actionTypes.js